const MOBILE_QUERY = "(max-width: 768px)"

export default class Title {
    timeline = new gsap.timeline();
    flipTriggers = []
    constructor({ el }) {
        this.el = el

        this.splitAnimated = el.classList.contains("split-animated")
        this.splitAnimatedHero = el.classList.contains("split-animated-hero")

        // The home intro (HomeHeroCover) owns the fullscreen headline until the
        // intro is over; it then hands the element over with a custom event.
        // Every other title is managed from the start: plain titles only get
        // the <br> handling for phones, split titles get the animations too.
        this.isIntroTitle = !!document.querySelector(".home-hero-cover")
            && !!el.closest(".wp-block-cinetic-creatives-blocks-grid.fullscreen")
            && !this.splitAnimated && !this.splitAnimatedHero
        this.managed = !this.isIntroTitle

        // Pristine markup, captured before any split. Every (re)layout starts
        // from this copy so manual <br> line breaks survive resizes.
        this.originalHTML = this.managed ? el.innerHTML : null
        this.lastWidth = window.innerWidth

        if (this.isIntroTitle) {
            this.boundHeroDone = () => {
                this.managed = true
                this.originalHTML = this.el.innerHTML
                this.handleResize()
            }
            el.addEventListener("cinetic:hero-done", this.boundHeroDone, { once: true })
        }

        this.handleResize();
        this.boundResize = this.handleResize.bind(this);
        this.boundWindowResize = this.handleWindowResize.bind(this);
        ScrollTrigger.addEventListener("refresh", this.boundResize)
        window.addEventListener("resize", this.boundWindowResize);
    }

    handleWindowResize() {
        // iOS fires resize when the address bar collapses while scrolling.
        // Only the width matters for the layout, so ignore height-only changes.
        if (window.innerWidth === this.lastWidth) return
        this.lastWidth = window.innerWidth
        this.handleResize()
    }

    resetMarkup() {
        this.el.innerHTML = this.originalHTML

        if (window.matchMedia(MOBILE_QUERY).matches) {
            // On phones the manual line breaks are dropped. Replace them with a
            // real space: hiding <br> with CSS makes some Safari versions drop
            // the space next to it, so words run together ("CLIENTPARTNERSHIP").
            this.el.querySelectorAll('br').forEach(br => br.replaceWith(document.createTextNode(" ")))
        }
    }

    handleResize() {
        this.flipTriggers.forEach(trigger => trigger.kill());
        this.flipTriggers = []
        this.split?.revert();
        this.split = null

        if (!this.managed) return

        this.resetMarkup()

        if (this.splitAnimated) {
            this.split = new SplitText(this.el, {
                type: "lines, words",
                linesClass: "flex-line",
                wordsClass: "flex-word"
            });
            gsap.set(this.split.lines, { 
                display: "flex", 
                justifyContent: "center",
                width: "100%",
                gap: "0.275em" 
            });

            gsap.set(this.split.words, { 
                display: "inline-flex",
                position: "relative",
            });


            this.split.lines.forEach((line, index) => {
                const lineWords = line.querySelectorAll(".flex-word");
                
                const state = Flip.getState(lineWords);

                gsap.set(line, { justifyContent: "space-between" });

               const trigger = Flip.to(state, {
                    duration: 1,
                    ease: "power3.inOut",
                    stagger: 0.05,
                    scrollTrigger: {
                        trigger: line,
                        start: "top 80%",
                        end: "top 50%",
                        scrub: true,
                        markers: false
                    }
                });

                this.flipTriggers.push(trigger)
            });
        } else if (this.splitAnimatedHero && !window.matchMedia(MOBILE_QUERY).matches) {

            this.split = new SplitText(this.el, {
                type: "lines, words",
                linesClass: "flex-line",
                wordsClass: "flex-word"
            });
            gsap.set(this.split.lines, { 
                display: "flex", 
                justifyContent: "center",
                width: "100%",
                gap: "0.275em" 
            });

            gsap.set(this.split.words, { 
                display: "inline-flex",
                position: "relative",
            });


            this.split.lines.forEach((line, index) => {
                const lineWords = line.querySelectorAll(".flex-word");
                
                const state = Flip.getState(lineWords);

                gsap.set(line, { justifyContent: "space-between" });

               const trigger = Flip.to(state, {
                    duration: 1,
                    ease: "power3.inOut",
                    delay: 0.05 * index
                });

                this.flipTriggers.push(trigger)
            });
        }

    }

    dispose() {
        ScrollTrigger.removeEventListener("refresh", this.boundResize)
        window.removeEventListener("resize", this.boundWindowResize);
        if (this.boundHeroDone) this.el.removeEventListener("cinetic:hero-done", this.boundHeroDone)

    }
}
